import { captureException } from '@sentry/react';

import {
  startEventsLogging,
  initAnalytics as _initAnalytics,
  isAnalyticsLoggingDisabledByUser,
  isAnalyticsLoggingPersisted,
} from '@cast/analytics';
import { isCastEmail, isE2E } from '@cast/utils';

import { resolveGlobalAttributes } from './heuristics/_resolveGlobalAttributes';
import { clickHeuristics } from './heuristics/click';
import { domMutationHeuristics } from './heuristics/dom-mutation';
import { IS_LOCALHOST } from '@cast/constants';

export type InitAnalyticsArgs = {
  email: string;
  orgID: string;
  orgName: string;
  enterpriseId?: string | null;
  enterpriseName?: string | null;
};

export const initAnalytics = (args: InitAnalyticsArgs) => {
  try {
    const isCastEmployee = isCastEmail(args.email);
    /* For CastAI employees and during development,
     * enable analytics logging to the dev console.
     * Logging will work even if analytics are disabled (or not initialized),
     * unless explicitly disabled by calling `disableAnalyticsLogging()` in the dev console.
     */
    if (
      (isCastEmployee || IS_LOCALHOST) &&
      !isE2E() &&
      !isAnalyticsLoggingDisabledByUser()
    ) {
      startEventsLogging();
    }
    // Restore persisted logging preference (set via window.enableAnalyticsLogging in dev console)
    if (isAnalyticsLoggingPersisted()) {
      startEventsLogging();
    }
    // Always register heuristics and the global attributes resolver so
    // event capturing works regardless of whether analytics are initialized.
    _initAnalytics({
      heuristics: {
        click: clickHeuristics,
        domMutation: domMutationHeuristics,
      },
      globalAttributesResolver: resolveGlobalAttributes,
      globalErrorHandler: captureException,
    });
  } catch (e) {
    console.error(e);
    captureException(e);
  }
};
